export default __webpack_public_path__ + "static/media/wastafels.a665a5d7.svg";